import React, {PureComponent} from "react";
import $ from "jquery";
import {formatDate} from "../functions/utils";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import MarshallWarningComponent from "../independentComponents/marshallWarningComponent";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class SessionStatusHistory extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            pageSize: 0,
            firstRecord: 0,
            rows: [],
            showTable: false,
            sessionDetails: {
                circuit: "---",
                circuit_id: -1,
                event_id: -1,
                length: 0,
                length_delimiter: "time",
                map_center_lat: 0,
                map_center_lng: 0,
                map_center_zoom_level: 0,
                map_rotation: 0,
                order_factor: "bestlap",
                session: "---",
                start_timestamp: 0,
                scheduled_start_timestamp: 0,
                timezone: "---",
                track_length: 0,
            },
            marshallPosts: [],
        };

        this.makeRows = this.makeRows.bind(this);
        this.getSessionDisplayLog = this.getSessionDisplayLog.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.popoutCode60Monitor = this.popoutCode60Monitor.bind(this);
        this.getMarshallPostList = this.getMarshallPostList.bind(this);
    }

    /* LIFECYCLE */
    componentDidMount() {
        $(".loading").fadeIn();
        this.getSessionDetails();
        this.getMarshallPostList();
    }

    /* GET DATA */
    getSessionDetails() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    sessionDetails: data,
                }, () => {
                    helper.getSessionDisplayLog();
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    getSessionDisplayLog() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionFlagsIssued',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: parseInt(helper.props.match.params.sessionID),
            },
            success: function (data) {
                helper.makeRows(data);
                helper.getMarshallPostList();
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                return false;
            }
        });
    }

    getMarshallPostList() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getMarshallPostList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: parseInt(helper.props.match.params.sessionID),
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        marshallPosts: data
                    });
                } else {
                    $(".loading").fadeOut();
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    /* POPOUT WINDOWS */
    popoutCode60Monitor(e) {
        e.preventDefault();
        window.open(
            "/code60monitor/" + this.props.match.params.eventID + "/" + this.props.match.params.sessionID + "/" + this.props.match.params.userID + "/" + e.currentTarget.value,
            'code60monitor',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,width=1000,height=800",
        );
    }

    /* RENDER */
    makeRows(issueList) {
        let rows;
        if (issueList && issueList.length > 0) {
            rows = (
                issueList.map((flag_issue, i) => {
                    if (flag_issue.sts_flag_type_by_sectors) {
                        let code60 = true;
                        for (let c = 0; c < flag_issue.sts_flag_type_by_sectors.length; c++) {
                            if (flag_issue.sts_flag_type_by_sectors[c].id !== 13) {
                                code60 = false;
                                break;
                            }
                        }

                        return (
                            <tr key={"issue_flag_" + i} className={"onHover App_white_text"}>
                                <td className={"text-center"}>
                                    {(code60 ? (
                                        <button
                                            value={flag_issue.id}
                                            style={{background: "#ff0003", fontWeight: "bold"}}
                                            type={"button"}
                                            className={"btn printWhite button"}
                                            onClick={this.popoutCode60Monitor}
                                            disabled={!flag_issue.flag_clear_date}
                                        >
                                            <i className="fas fa-search" style={{color: "#FFFFFF"}}/>
                                        </button>
                                    ) : null)}
                                </td>
                                <td className={"text-center"}>
                                    <MarshallWarningComponent
                                        marshallPosts={this.state.marshallPosts}
                                        sendFlag={null}
                                        fullCourseFlags={null}
                                        sessionStatus={flag_issue.sts_flag_type_by_sectors}
                                        isSingleVehicle={true}
                                        enableClick={false}
                                        isFlagPanel={false}
                                        hasTooltip={false}
                                    />
                                </td>
                                <td className={"text-center"}>
                                    {formatDate(parseInt(flag_issue.flag_issue_date), this.state.sessionDetails.timezone)}
                                </td>
                                <td className={"text-center"}>
                                    {formatDate(parseInt(flag_issue.flag_clear_date), this.state.sessionDetails.timezone)}
                                </td>
                            </tr>
                        );
                    } else {
                        rows = null;
                        return false;
                    }
                })
            );
        } else {
            rows = null;
        }

        this.setState({
            rows: rows,
        }, () => {
            $(".loading").fadeOut();
        });
    }

    render() {
        return (
            <>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <div className={"App_ContainerStyle table-scroll-parent"} style={{whiteSpace: "nowrap", margin: 10}}>
                    <div className={"table-scroll-child table-responsive"}>
                        <table className={"table table-hover table-condensed"} style={{textAlign: "center"}}>
                            <thead>
                            <tr>
                                <th className={"App_header text-center"} style={{width: "2%"}}/>
                                <th className={"App_header text-center"} style={{width: "35%"}}>{this.props.t("sessionState").toUpperCase()}</th>
                                <th className={"App_header text-center"} style={{width: "11%"}}>{this.props.t("issue").toUpperCase()}</th>
                                <th className={"App_header text-center"} style={{width: "11%"}}>{this.props.t("clear").toUpperCase()}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.rows}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(SessionStatusHistory));
